import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import './index.css'
import { captureInstallPromptEarly, isIosDevice } from './lib/pwaInstall'
import { registerHubServiceWorker } from './lib/push'

captureInstallPromptEarly()

const rootEl = document.getElementById('root')
if (!rootEl) {
  document.body.textContent = 'Falha ao carregar o Hub (elemento raiz ausente).'
} else {
  try {
    createRoot(rootEl).render(
      <StrictMode>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </StrictMode>,
    )
  } catch (err) {
    const msg = err instanceof Error ? err.message : 'erro desconhecido'
    rootEl.innerHTML =
      '<p style="padding:1.5rem;font-family:system-ui;max-width:24rem;margin:2rem auto;text-align:center">' +
      '<strong>Não foi possível abrir o Hub.</strong><br/>' +
      'Atualize a página ou limpe dados deste site no Safari.<br/>' +
      '<a href="/login?classic=1">Entrar pelo site clássico</a>' +
      '<br/><small style="color:#6b7280">' +
      msg +
      '</small></p>'
  }
}

// Android: SW cedo ajuda beforeinstallprompt. iOS: após paint (evita tela branca).
if (!isIosDevice()) {
  void registerHubServiceWorker()
}
window.setTimeout(() => {
  void registerHubServiceWorker()
}, 0)
